import MultiViewerWrapper from 'src/components/MultiViewer/MultiViewerWrapper/MultiViewerWrapper';

export default MultiViewerWrapper;